const responsiveFilterDropdownRoot = {
  borderRadius: 6,
  minWidth: 280,
  maxWidth: "calc(100vw - 32px)",
  maxHeight: "min(420px, calc(100vh - 160px))",
  overflowY: "auto",
};

export const responsiveFilterSelectProps = {
  popupMatchSelectWidth: false,
  classNames: {
    popup: {
      root: "responsive-filter-dropdown",
    },
  },
  styles: {
    popup: {
      root: responsiveFilterDropdownRoot,
    },
  },
};

